<template>
    <el-container class="layout-container">
        <el-header></el-header>
        <el-container>
            <el-aside>
                <el-menu :router="true" :default-active="this.$route.path" :default-openeds="['1']">
                    <el-sub-menu index="1">
                        <template #title>
                            <el-icon><document /></el-icon>
                            <span>AI</span>
                        </template>
                        <el-menu-item index="/ai/prompt">Prompt</el-menu-item>
                        <el-menu-item index="/ai/issue">Issue</el-menu-item>
                        <el-menu-item index="/ai/chat">Chat</el-menu-item>
                    </el-sub-menu>
                </el-menu>
            </el-aside>
            <el-main>
                <router-view></router-view>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
import { Document, Location } from '@element-plus/icons-vue';

export default {
    components: {
        Document,
        Location,
    },
};
</script>

<style scoped>
.layout-container .el-header {
    position: relative;
    border-bottom: 1px solid #ebeef5;
    height: 50px;
}

.layout-container .el-aside {
    width: 230px;
}

.layout-container .el-menu {
    padding-top: 0;
    border-right: 0;
}
.el-menu-item.is-active {
    background-color: rgba(64, 158, 255, 0.1);
}

.layout-container .el-main {
    padding: 50px;
}
</style>
